import React, { useEffect, useState } from "react";
import Hoc from "../../components/HOC";
import { useNavigate } from "react-router-dom";
import ModalComponent from "../../components/Modal";
import FileUploadComponent from "../../components/FileUploadComponent";
import {
  EditUserSchema,
  getValuesFromLocalstorage,
} from "../../components/Helpers";
import { useDispatch, useSelector } from "react-redux";
import {
  requestProfileAction,
  requestUpdateProfileForUser,
  setResetUpdateProfiileForUser,
} from "../../Redux/ProfileState/ProfileActionCreator";
import Loader from "../../components/Loader";
import {
  requestUploadFileAction,
  setResetStateuploadFile,
} from "../../Redux/FileState/uploadFileActionCreator";
import { toast } from "react-toastify";
import {
  requestEdituser,
  setResetStateEditUser,
} from "../../Redux/UserState/UserActionCreator";
import { Formik, Form } from "formik";
import { Pencil } from "lucide-react";
import TextInput from "../../components/TextInput";
import CustomDropdown from "../../components/CustomDropdown";
import { MdEdit } from "react-icons/md";
import LOCAL_KEYS, { setToLocalStorage } from "../../helpers/Localstorage";

const EmployeeProfile = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const userDetails = getValuesFromLocalstorage("userDetails");
  const ProfileReducer = useSelector((state) => state.ProfileReducer);
  const fileUploadReducer = useSelector((state) => state.UploadFileReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const editUserReducer = useSelector((state) => state.EditUserReducer);
  const updateUserReducer = useSelector(
    (state) => state.UpdateProfileUserReducer
  );
  const [profile, setProfile] = useState(userDetails || {});

  const countryOptions = [
    { value: "USA", label: "USA" },
    { value: "IN", label: "IN" },
  ];

  // useEffect(() => {
  //   if (userDetails) {
  //     dispatch(requestProfileAction(userDetails?.id));
  //   }
  // }, []);

  const uploadDocumentFuction = () => {
    handleDrawerOpen();
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };
  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };
  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };
  const handleCancel = () => {
    setIsEditing(false);
  };
  const fileSave = (file) => {
    dispatch(requestUploadFileAction({ file: file }));
  };

  useEffect(() => {
    if (ProfileReducer?.response) {
      setProfile(ProfileReducer?.response);
    }
  }, [ProfileReducer]);

  useEffect(() => {
    if (!fileUploadReducer?.Loading && fileUploadReducer?.Response) {
      toast.success("File Uploaded Sucessfully");
      handleDrawerClose();
      dispatch(setResetStateuploadFile());
    }
  }, [fileUploadReducer]);

  useEffect(() => {
    if (updateUserReducer?.response && !updateUserReducer?.loading) {
      setToLocalStorage(LOCAL_KEYS.USER_DETAILS, updateUserReducer.response);
      setIsEditing(false);
      toast.success("Profile Updated Successfully");
      dispatch(setResetUpdateProfiileForUser());
    } else if (updateUserReducer?.error && !updateUserReducer?.loading) {
      toast.error("Error Updating Profile");
      dispatch(setResetUpdateProfiileForUser());
    }
  }, [updateUserReducer]);

  return (
    <div className="h-[80vh] bg-gray-100 p-4 md:p-8 overflow-y-scroll">
      <Loader isLoading={ProfileReducer.loading || updateUserReducer.loading} />
      <ModalComponent
        show={isDrawerOpen}
        onClose={handleDrawerClose}
        title={"Upload Background Image"}
      >
        <FileUploadComponent
          accept={[".jpg", ".jpeg", ".png"]}
          fileSave={fileSave}
        />
      </ModalComponent>
      <div className=" mx-auto rounded-lg h-[60vh] overflow-hidden">
        <div className="flex flex-col md:flex-row">
          <div className="w-full md:w-1/5 pt-24 border-b md:border-b-0 md:border-r border-gray-200 flex flex-col items-center">
            <div className="w-44 h-44 rounded-full bg-cyan-600 flex items-center justify-center text-white text-3xl font-bold ">
              {profile?.firstName?.charAt(0)?.toUpperCase()}
              {profile?.lastName?.charAt(0)?.toUpperCase()}
            </div>
            <h2 className="text-xl font-semibold text-center ">
              {ProfileReducer?.response
                ? `${ProfileReducer?.response?.firstName} ${ProfileReducer?.response?.lastName}`
                : `${userDetails?.firstName} ${userDetails?.lastName}`}
            </h2>
            <p className="text-gray-500 text-sm mb-6 ">
              {ProfileReducer?.response?.acctType || userDetails?.acctType}
            </p>
            {userDetails?.acctType === "ADMIN" && (
              <button
                onClick={uploadDocumentFuction}
                className="bg-primary hover:bg-primaryDark text-white py-2 px-4 float-right rounded-lg"
              >
                Upload Background Image
              </button>
            )}
          </div>
          <div className="w-full md:w-4/5 p-6 relative ">
            <span className="flex justify-between items-center sticky top-0 p-4 z-10">
              <h3 className="text-xl font-semibold">Profile Information</h3>
              {!isEditing && (
                <button
                  className="text-primary hover:text-primaryDark"
                  onClick={() => setIsEditing(true)}
                >
                  <MdEdit size={24} />
                </button>
              )}
            </span>
            <div className="w-full  p-6">
              <Formik
                initialValues={userDetails || {}}
                enableReinitialize
                onSubmit={(values, { setSubmitting }) => {
                  dispatch(requestUpdateProfileForUser({ user: values }));
                  setIsEditing(false);
                  setSubmitting(false);
                }}
                validationSchema={EditUserSchema}
              >
                {({ handleChange, values, setFieldValue, handleSubmit, isSubmitting, errors, touched, resetForm }) => (
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSubmit(e);
                    }}
                    className="grid grid-cols-2 gap-x-6 gap-y-4 p-2 mb-2 h-[44vh]"
                  >
                    {/* <div className="grid grid-cols-2 gap-4"> */}
                    <div>
                      <TextInput
                        value={`${values.firstName} ${values.lastName}`}
                        name="fullname"
                        placeholder="Full Name"
                        bgColor="bg-gray-100"
                        legend
                        isDisabled
                        handleChange={handleChange}
                      />
                    </div>
                    <TextInput
                      value={values.email}
                      name="email"
                      placeholder="Email"
                      legend
                      bgColor="bg-gray-100"
                      isDisabled
                      handleChange={handleChange}
                    />
                    <div className="relative">
                      <TextInput
                        value={values.phone}
                        name="phone"
                        legend
                        placeholder="Phone Number"
                        bgColor="bg-gray-100"
                        type="tel"
                        handleChange={handleChange}
                        isDisabled={!isEditing}
                      />
                      {errors.phone && touched.phone && (
                        <div className="text-red-500 text-sm text-left">{errors.phone}</div>

                      )}
                    </div>
                    <div>
                    <TextInput
                      value={values.addressLine1}
                      legend
                      name="addressLine1"
                      placeholder="Address"
                      handleChange={handleChange}
                      bgColor="bg-gray-100"
                      isDisabled={!isEditing}
                    />
                    {errors.addressLine1 && touched.addressLine1 && (
                      <div className="text-red-500 text-sm text-left">{errors.addressLine1}</div>
                    )}
                    </div>
                    <TextInput
                      value={values.addressLine2}
                      name="addressLine2"
                      legend
                      bgColor="bg-gray-100"
                      placeholder="Address Line 2"
                      handleChange={handleChange}
                      isDisabled={!isEditing}
                    />
                   
                    <div>
                    <TextInput
                      value={values.city}
                      name="city"
                      legend
                      placeholder="City"
                      handleChange={handleChange}
                      bgColor="bg-gray-100"
                      isDisabled={!isEditing}
                    />
                    {errors.city && touched.city && (
                      <div className="text-red-500 text-sm text-left">{errors.city}</div>
                    )}
                    </div>
                    <div>
                    <TextInput
                      value={values.state}
                      name="state"
                      legend
                      placeholder="State"
                      handleChange={handleChange}
                      bgColor="bg-gray-100"
                      isDisabled={!isEditing}
                    />
                    {errors.state && touched.state && (
                      <div className="text-red-500 text-sm text-left">{errors.state}</div>
                    )}
                    </div>
                    <div className="[&>div]:bg-gray-100 [&>div>div]:bg-gray-100 [&>div>div>div]:bg-gray-100 [&>div>label]:bg-slate-100 [&>div>div]:border-b-2 [&>div>div]:border-gray-100 [&>div>div>div>div]:text-black [&>div>div>div>div>div]:text-black -mt-1">
                      <CustomDropdown
                        value={countryOptions.find(
                          (user) => user?.value === values?.country
                        )}
                        name="country"
                        handleChange={(selectedOption) =>
                          setFieldValue("country", selectedOption.value)
                        }
                        placeholder="Select Country"
                        options={countryOptions}
                        isDisabled={!isEditing}
                        bgColor="bg-gray-100"
                        legend
                      />
                    </div>
                    {/* </div> */}
                    <div></div>
                    <div className={`${!isEditing && "hidden"}`}>
                      <span className="w-full flex justify-end ">
                        <button
                          type="button"
                          onClick={() => {
                            setIsEditing(false)
                            resetForm()
                          }
                          }
                          className="bg-gray-300 text-black rounded p-2 hover:bg-gray-400 mr-2 w-1/3"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          onClick={(e) => {
                            e.preventDefault();
                            handleSubmit(e);
                          }}
                          className={`btn-submit bg-primary rounded p-2 hover:bg-blue-400 w-1/3 text-white ${!isEditing ? "opacity-50 cursor-not-allowed" : ""
                            }`}
                          disabled={!isEditing || isSubmitting}
                        >
                          {isSubmitting ? 'Submitting...' : 'Submit'}
                        </button>
                      </span>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hoc(EmployeeProfile);
